import React from 'react';
import mainContext from '../../../contexts/mainContext';
import { addHouseKeeperAvailableForController, deleteData, getHouseKeeperAvailableForController } from '../../../Controllers/AppManagement/houseKeeper';
import { __constants, __snackBarText, __snackBarSeverity } from '../../../constants';
import ImageTextListManager from '../common/ImageTextListManager';

export default function HouseKeeperAvailableFor() {
  const { setProfileNavTitle } = React.useContext(mainContext);
  return (
    <ImageTextListManager
      navTitle="Housekeeper availability"
      dialogTitle="Add new availability"
      textLabel="Availability"
      getData={getHouseKeeperAvailableForController}
      addData={addHouseKeeperAvailableForController}
      deleteData={deleteData}
      editTitle="Update availability"
      setProfileNavTitle={setProfileNavTitle}
      __constants={__constants}
      __snackBarText={__snackBarText}
      __snackBarSeverity={__snackBarSeverity}
      mainContext={mainContext}
    />
  );
}